module.exports = __webpack_public_path__ + "img/10.7771ec09.jpg";